export default "__VITE_ASSET__DyLIVUSe__"